 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		78: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"BizKycBusinessActivities~BizKycInformation~BizKycIntendedRelations~BizKycReview~BizKycStatus~BizKycU~435d50f9","2":"StraitsXBizKycAccountManager~StraitsXBizKycBusinessActivities~StraitsXBizKycComplete~StraitsXBizKycD~ee002959","3":"vendors~BizKycBusinessActivities~BizKycInformation~BizKycIntendedRelations~BizKycReview~BizKycStatus~30c8af64","7":"vendors~GetStarted~LandingPage~MintSetup~MyAccount~StraitsXLandingPage~StraitsXMyAccount","10":"GetStarted~MintSetup~MyAccount~StraitsXMyAccount","11":"StraitsXTransactionDetails~StraitsXTransactions~TransactionDetails~Transactions","12":"Verification~VerificationClaimKyc~VerificationInternationalFlow~VerificationSgFlow","13":"vendors~GetStarted~LandingPage~MintSetup~StraitsXLandingPage","16":"Deposit~Mint~StraitsXDeposit","17":"Earn~Mint~Verification","18":"VerificationClaimKyc~VerificationInternationalFlow~VerificationSgFlow","21":"StraitsXBizKycDirectorsAndBo~StraitsXBizKycUploadDocuments","22":"StraitsXVerification~VerificationClaimKyc","23":"vendors~LandingPage~StraitsXLandingPage","24":"vendors~Verification~VerificationSgFlow","27":"BizKycBusinessActivities","28":"BizKycInformation","29":"BizKycIntendedRelations","30":"BizKycReview","31":"BizKycStatus","32":"BizKycUploadDocuments","33":"Deposit","34":"Earn","35":"EarnTransactionDetails","36":"Error","37":"GetStarted","38":"InternalTools","39":"LandingPage","40":"Mint","41":"MintSetup","42":"MyAccount","43":"NotFound","44":"StraitsXAccountStatement","45":"StraitsXBizKycAccountManager","46":"StraitsXBizKycBusinessActivities","47":"StraitsXBizKycComplete","48":"StraitsXBizKycDirectorsAndBo","49":"StraitsXBizKycInformation","50":"StraitsXBizKycIntendedRelations","51":"StraitsXBizKycReview","52":"StraitsXBizKycTaxResidency","53":"StraitsXBizKycUploadDocuments","54":"StraitsXDeposit","55":"StraitsXDeveloperTools","56":"StraitsXEarn","57":"StraitsXEarnTransactionDetails","58":"StraitsXLandingPage","59":"StraitsXMyAccount","60":"StraitsXSimulateDeposit","61":"StraitsXTransactionDetails","62":"StraitsXTransactions","63":"StraitsXVerification","64":"StraitsXWithdraw","65":"Team","66":"TransactionDetails","67":"Transactions","68":"Verification","69":"VerificationClaimKyc","70":"VerificationInternationalFlow","71":"VerificationSgFlow","72":"Withdraw","73":"XIDRGetStarted","74":"XIDRSandbox","75":"XIDRTeam","76":"XIDRTransactionDetails","77":"XIDRTransactions"}[chunkId]||chunkId) + "." + {"0":"a3f6f49c","1":"421a4248","2":"b37d81f4","3":"88cf5255","4":"c5602860","5":"3f8f0148","6":"1e856bdf","7":"e10de2c7","8":"1726f057","9":"2086e942","10":"956d288b","11":"2f2f16f7","12":"c42d6746","13":"91d0f784","14":"7c6f4e0b","15":"b66b46de","16":"816b2bbb","17":"f06cf26e","18":"1f5cf909","19":"8d178bc6","20":"da67098f","21":"c63f845d","22":"16639ff2","23":"bea673e1","24":"3a643ccf","25":"edb24fb0","26":"51df1975","27":"538a12ba","28":"82ffb1aa","29":"8b955cea","30":"5c6a08e1","31":"d4959e9d","32":"27b98e57","33":"a3a00f51","34":"6ac4c6a7","35":"c2760923","36":"72fbb7d7","37":"c18e4e86","38":"a71ecb0e","39":"beac993e","40":"926c77b6","41":"9320488b","42":"8338752d","43":"c0d1fde2","44":"871d7f63","45":"89838a7d","46":"99c26334","47":"829b44b0","48":"77dd4f3c","49":"7f1b14d7","50":"3ab1c5c1","51":"3d2f8eb0","52":"12ac7407","53":"1b1b10fe","54":"66b72e7f","55":"1274f6ab","56":"6526bf88","57":"ae98bab7","58":"354bac25","59":"562912fc","60":"d6cda95c","61":"61ab65a3","62":"9000d07d","63":"34891ee6","64":"b6636dcc","65":"32f3a0d2","66":"641f5279","67":"c1ed2d7b","68":"0198600c","69":"bf2db62e","70":"8071e2c7","71":"4b8734ac","72":"60b5b06c","73":"90f7cbb0","74":"13431b67","75":"ee3fe56c","76":"64021622","77":"1ad1dfd8","79":"4937eef4","80":"c1d6ef4a","81":"da0727e7","82":"2e7a7a7f","83":"1cb99b0d","84":"60df083e","85":"37484d6b","86":"9e1f740b","87":"d752531b","88":"ca01de0f","89":"f3613620","90":"664e4894"}[chunkId] + ".sg.app.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d3r7nsslvs6aaf.cloudfront.net/frontend/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 530);
